/**
 * Responses public/index.html starts fetching before the JS bundle has loaded — on a first
 * visit to the home page, a head start of the whole download-parse-render time.
 *
 * A response is handed out only for the identical URL, once (a body can be read only once),
 * and only while fresh. Anything else goes to the network as usual, so a mismatch between the
 * inline script and the app costs a duplicate request, never wrong data.
 *
 * Deliberately imports nothing: i18n and the API client both read it during start-up.
 */
// Generous on purpose: the connections slow enough to take this long to boot are the ones the
// head start matters most for, and the data is well inside React Query's 5-minute staleTime.
const MAX_AGE_MS = 120000;

/**
 * @param {string} url - Absolute URL, as the request would be sent
 * @returns {Promise<Response>|null}
 */
export const takePrefetched = (url) => {
  const store = typeof window !== 'undefined' ? window.__diilPrefetch : undefined;
  const entry = store && store[url];
  if (!entry) return null;
  delete store[url];
  return Date.now() - entry.at <= MAX_AGE_MS ? entry.response : null;
};
